/**
 * Drop-in replacement for fetch() that automatically includes:
 * - credentials: 'include' (sends session + XSRF cookies)
 * - X-XSRF-TOKEN header on state-changing methods (POST/PUT/DELETE/PATCH)
 *
 * Usage: import apiFetch from '../utils/apiFetch';
 *        apiFetch('/api/foo', { method: 'POST', body: ... })
 */
import { getCsrfToken } from './csrfToken';

// Rewrite URLs pointing to build-time backend to current tenant origin
const _buildTimeUrl = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
function resolveUrl(url) {
  if (window.__BACKEND_URL && _buildTimeUrl && url.startsWith(_buildTimeUrl)) {
    return url.replace(_buildTimeUrl, window.__BACKEND_URL);
  }
  return url;
}

export default function apiFetch(url, options = {}) {
  const method = (options.method || 'GET').toUpperCase();
  const needsCsrf = ['POST', 'PUT', 'DELETE', 'PATCH'].includes(method);

  const headers = new Headers(options.headers || {});

  if (needsCsrf) {
    const token = getCsrfToken();
    if (token) {
      headers.set('X-XSRF-TOKEN', token);
    }
  }

  return fetch(resolveUrl(url), {
    ...options,
    headers,
    credentials: 'include',
  });
}
